
import _ from 'lodash';
import React from 'react';
import { NavLink } from 'react-router-dom';

import Expandable from 'components/global/application/Expandable';

export interface Props {
    brandName: string;
    brandModel: string;
    className: string;
    year: string;
}

interface State {
    expanded: boolean;
}

class BrandInfoYearSelect extends React.Component<Props, State> {
    public constructor(props: any) {
        super(props);
        this.state = { expanded: false };
    }

    public showOptionsToggle = () => {
        this.setState({ expanded: !this.state.expanded });
    }

    public selectLabelFromYear = () => {
        switch (this.props.year) {
            case 'new':
                return 'New Instruments';
            case 'used':
                return 'Used Instruments';
            default:
                return 'All Instruments';
        }
    }

    public urlValueForYear = (year: string) => {
        return year || 'all';
    }

    public buildUrlLink = (year: string) => {
        const brandModel = this.props.brandModel || '';
        return '/brands/' + this.props.brandName + '/' + this.urlValueForYear(year) + '/' + brandModel;
    }

    public render() {
        return (
            <div className={`${ this.props.className }`}>
                <div className="InventoryFilter-container-mobile Select Select--single Filter-options-dropdown"  onClick={this.showOptionsToggle}>
                    <div className="Select-look-alike">
                        {this.selectLabelFromYear()}
                        <span className="Select-arrow Select-arrow-lookalike" />
                    </div>
                    <Expandable className="InventoryFilterOptions-container-mobile" expanded={this.state.expanded} direction="vertical" maxHeight="860px">
                        <div className="PadBottom-container">
                            <div><NavLink to={this.buildUrlLink('new')}>New Instruments</NavLink></div>
                            <div><NavLink to={this.buildUrlLink('used')}>Used Instruments</NavLink></div>
                            <div><NavLink to={this.buildUrlLink('all')}>All Instruments</NavLink></div>
                        </div>
                    </Expandable>
                </div>
            </div>
        );
    }
}

export default BrandInfoYearSelect;



// WEBPACK FOOTER //
// ./src/components/pages/brand/BrandInfoYearSelect.tsx